import {removeStyleClass} from "../../common/colors";

/**
 * Replaces action link keywords with various properties from available data.
 *
 * EX: The following tag creates a Click Menu Row for the Web Auth's Properties page.
 * 			<csp:clickMenuRow type="EDIT"
 *							  link="AddEditCtrl.act?ngaId=@ROWID"
 *							  targetParent="true"/>
 *
 * @param link
 * @returns {*}
 */
export function replaceClickMenuKeywords(link) {
    if (!link) {
        console.error("Failed to replace click menu keywords...");
        return;
    }

    const { clickMenu, pageData } = GlobalEnt;
    const { rowId, optParam1, optParam2 } = clickMenu;
    const { params, vaultId, serial, doorId } = pageData;
    const { eid, etype } = params;

    if (link.includes('@ROWID')) {
        link = link.replace('@ROWID', rowId);
    }
    if (link.includes('@PARAM1')) {
        link = link.replace('@PARAM1', optParam1);
    }
    if (link.includes('@PARAM2')) {
        link = link.replace('@PARAM2', optParam2);
    }
    if (link.includes('@EID')) {
        link = link.replace('@EID', eid);
    }
    if (link.includes('@ETYPE')) {
        link = link.replace('@ETYPE', etype);
    }
    if (link.includes('@VAULTID')) {
        link = link.replace('@VAULTID', vaultId);
    }
    if (link.includes('@SERIAL')) {
        link = link.replace('@SERIAL', serial);
    }
    if (link.includes('@DOORID')) {
        link = link.replace('@DOORID', doorId);
    }
    return link;
}

export function loadLink(link) {
    if (!link) {
        console.error("Failed to load link...");
        return;
    }

    window.location = replaceClickMenuKeywords(link);
}

export function showClickMenu(e) {
    let evt = e ? e : window.event;
    let eTargetIsSubMenu = !!(findParentDiv(evt) || findChildDiv(evt));

    const { clickMenu, dbMenu } = GlobalEnt;

    if (clickMenu.hideTimer !== 0) {
        clearTimeout(clickMenu.hideTimer);
        clickMenu.hideTimer = 0;
    }

    eTargetIsSubMenu ? cancelHideEvents() : hideSubMenu();

    if (dbMenu)
        dbMenu.hidePrevious();
}

export function showSubMenu(subMenu) {
    let rows = subMenu.getElementsByTagName("ul");
    let top1 = subMenu.clientHeight - subMenu.offsetHeight;
    let childDiv = subMenu.getElementsByTagName("div")[0];

    // cancel any hide events
    cancelHideEvents();

    // Make the submenu hideable (and replace the ones set by the parent)!
    if (!("ontouchstart" in window)) {
        childDiv.addEventListener('mouseleave', function() {
            hideAllMenus();
        });
        childDiv.addEventListener('mouseover', function() {
            cancelHideEvents();
        });
    }

    childDiv.style.top = top1 + 'px';
    childDiv.style.left = subMenu.clientWidth + 'px';
    childDiv.style.display = 'block';

    if (GlobalEnt.clickMenu.activeSubMenu != null && GlobalEnt.clickMenu.activeSubMenu !== subMenu) {
        doHideSubMenu();
    }

    GlobalEnt.clickMenu.activeSubMenu = subMenu;

    for (let i = 0; i < rows.length; i++) {
        rows[i].style.display = "block";
    }
}

export function hideAllMenus() {
    hideClickMenu();
    hideSubMenu();
}

export function cancelHideEvents(e) {
    if (e === undefined)
        e = window.event;

    // clear the submenu hide timer
    if (GlobalEnt.clickMenu.hideSubTimer !== 0) {
        clearTimeout(GlobalEnt.clickMenu.hideSubTimer);
        GlobalEnt.clickMenu.hideSubTimer = 0;
    }

    // clear the parent hide timer as well
    if (GlobalEnt.clickMenu.hideTimer !== 0) {
        clearTimeout(GlobalEnt.clickMenu.hideTimer);
        GlobalEnt.clickMenu.hideTimer = 0;
    }

    // stop event bubbling!
    if (window.event)
        window.event.cancelBubble = true;

    if ((e !== undefined) && (e.stopPropagation))
        e.stopPropagation();
}

export function hideClickMenu() {
    if (GlobalEnt.clickMenu.hideTimer === 0) {
        GlobalEnt.clickMenu.hideTimer = self.setTimeout(doHideClickMenu, 500);
    }
}

export function hideSubMenu() {
    if (GlobalEnt.clickMenu.hideSubTimer === 0
        && GlobalEnt.clickMenu.activeSubMenu != null) {
        GlobalEnt.clickMenu.hideSubTimer = self.setTimeout(doHideSubMenu, 500);
    }
}

export function doHideClickMenu() {
    if (GlobalEnt.clickMenu.currentlyShowingMenu != null) {
        GlobalEnt.clickMenu.currentlyShowingMenu.style.display = "none";

        // set the element class to reset its behavior
        if (GlobalEnt.clickMenu.clickedElem != null) {
            removeStyleClass(GlobalEnt.clickMenu.clickedElem, 'selectedClickRow');
        }

        GlobalEnt.clickMenu.currentlyShowingMenu = null;

        // hide any visible submenu as well
        hideSubMenu();
    }
}

export function doHideSubMenu() {
    if (GlobalEnt.clickMenu.activeSubMenu != null) {
        const rows = GlobalEnt.clickMenu.activeSubMenu.getElementsByTagName("ul");

        GlobalEnt.clickMenu.activeSubMenu.getElementsByTagName("div")[0].style.display = "none";

        for (let i = 0; i < rows.length; i++) {
            rows[i].style.display = "none";
        }

        GlobalEnt.clickMenu.activeSubMenu = null;
        GlobalEnt.clickMenu.hideSubTimer = 0;
    }
}

export function findParentDiv(evt) {
    let findDiv = evt && evt.target ? evt.target : null;
    while (findDiv && findDiv.tagName !== "DIV")
        findDiv = findDiv.parentNode;

    return findDiv && (/clickSubMenu/i).test(findDiv.className) ? findDiv : null;
}

export function findChildDiv(evt) {
    const findDiv = evt && evt.target ? evt.target.getElementsByTagName("div") : null;
    return findDiv && findDiv.length > 0 ? findDiv[0] : null;
}

export function cancelClickHide() {
    if (GlobalEnt.clickMenu.hideTimer !== 0) {
        clearTimeout(GlobalEnt.clickMenu.hideTimer);
    }
}

export function getElement(e) {
    let clickedElm = null;

    if (!e)
        e = window.event;

    if (e.target)
        clickedElm = e.target;
    else if (e.srcElement)
        clickedElm = e.srcElement;

    // Safari target workaround
    if ((clickedElm != null) && (clickedElm.nodeType == 3))  //3=TEXT
        clickedElm = clickedElm.parentNode;

    return clickedElm;
}

/**
 * Checks to see if the <li/> elements match the display flags.
 * @param liElm
 * @param displayFlags
 * @returns {boolean}
 */
export function matchesDisplayFlags(liElm, displayFlags) {
    //menu entries that declare zero display flags are always visible
    //surround with spaces to make indexOf() match whole words only in loop below
    const cssClasses = ' ' + String(liElm.className) + ' ';
    if (cssClasses.indexOf(' _dc_') === -1)
        return true;

    for (let i = 0; i < displayFlags.length; i++) {
        if (displayFlags[i] === '*' || cssClasses.indexOf(' _dc_' + displayFlags[i] + ' ') !== -1)
            return true;
    }

    return false;
}